<template>
  <section class="">
    <div class="container items-center lg:w-5/6">
      <h3 class="section--h3 text-4xl">Important to Remember</h3>
      <p class="section--p text-base">
        Microlearning =/= Chopping Up Long Content
      </p>
      <vs-card class="w-full mb-base items-left">
        <div class="alex-title p-5">
          <div class="w-1/10">
            <div class="number-bullet mr-4">1</div>
          </div>
          Customize according to relevant segmentation
        </div>
        <div class="p-5 items-left">
          <div class="tips-heading mb-base">We segment on the basis of</div>
          <ul class="tips-list">
            <li>
              <vs-icon
                class="mr-3"
                color="#FBA727"
                icon="icon-check-circle"
                icon-pack="feather"
              />Purpose of role
            </li>
            <li>
              <vs-icon
                class="mr-3"
                color="#FBA727"
                icon="icon-check-circle"
                icon-pack="feather"
              />Employee Performance
            </li>
            <li>
              <vs-icon
                class="mr-3"
                color="#FBA727"
                icon="icon-check-circle"
                icon-pack="feather"
              />Work Level in Organization
            </li>
            <li>
              <vs-icon
                class="mr-3"
                color="#FBA727"
                icon="icon-check-circle"
                icon-pack="feather"
              />Speed of career progression
            </li>
          </ul>
        </div>
      </vs-card>
      <vs-card class="w-full mb-base items-left">
        <div class="alex-title p-5">
          <div class="w-1/10">
            <div class="number-bullet mr-4">2</div>
          </div>
          Customize according to preferences</div>
        <div class="p-5 items-left">
          <div class="tips-heading mb-base">So we can</div>
          <ul class="tips-list">
            <li>
              <vs-icon
                class="mr-3"
                color="#FBA727"
                icon="icon-check-circle"
                icon-pack="feather"
              />Customize relevant offerings
            </li>
            <li>
              <vs-icon
                class="mr-3"
                color="#FBA727"
                icon="icon-check-circle"
                icon-pack="feather"
              />Allocate the right resources
            </li>
            <li>
              <vs-icon
                class="mr-3"
                color="#FBA727"
                icon="icon-check-circle"
                icon-pack="feather"
              />Identify the right strategies of growth
            </li>
            <li>
              <vs-icon
                class="mr-3"
                color="#FBA727"
                icon="icon-check-circle"
                icon-pack="feather"
              />Make the right investment decisions in L&D
            </li>
          </ul>
        </div>
      </vs-card>
      <vs-card class="w-full mb-base items-left">
        <div class="alex-title p-5">
          <div class="w-1/10">
            <div class="number-bullet mr-4">3</div>
          </div>
          Customize according to feedback</div>
        <div class="p-5 items-left">
          <div class="tips-heading mb-base">
            So our training library is always
          </div>
          <ul class="tips-list">
            <li>
              <vs-icon
                class="mr-3"
                color="#FBA727"
                icon="icon-check-circle"
                icon-pack="feather"
              />Up to date and dynamically being sorted based on quality
            </li>
            <li>
              <vs-icon
                class="mr-3"
                color="#FBA727"
                icon="icon-check-circle"
                icon-pack="feather"
              />Evolving as per the needs of the organization
            </li>
            <li>
              <vs-icon
                class="mr-3"
                color="#FBA727"
                icon="icon-check-circle"
                icon-pack="feather"
              />Suggesting better learning content with iterative feedback
            </li>
            <li>
              <vs-icon
                class="mr-3"
                color="#FBA727"
                icon="icon-check-circle"
                icon-pack="feather"
              />Giving a participative sense of contribution to the learner
            </li>
          </ul>
        </div>
      </vs-card>
    </div>
  </section>
</template>

<script>
export default {
  name: "ImpRemember",
};
</script>

<style scoped>
.items-center {
  text-align: center;
  text-align: -moz-center;
  text-align: -webkit-center;
}
.items-left {
  text-align: left;
  text-align: -moz-left;
  text-align: -webkit-left;
}

section {
  padding: 10rem;
  background: #f7f8f9;
  position: relative;
}

.section__h3 {
  font-style: normal;
  font-weight: 900;
  font-size: 40px;
  line-height: 55px;

  color: #231d4f;
}

.section__p {
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 26px;

  color: #848199;
}

.con-vs-card {
  box-shadow: 0px 4px 36px rgba(24, 144, 251, 0.1);
}

.con-vs-card >>> .vs-card--content {
  padding: 0 !important;
}

.alex-title {
  background: rgba(220, 0, 50, 0.1);
  border-radius: 12px 12px 0px 0px;
  font-style: normal;
  font-weight: bold;
  font-size: 20px;
  line-height: 24px;
  color: #dc0032;
  display: flex;
  align-items: center;
}

.alex-content div {
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  line-height: 140%;
  display: flex;
  align-items: center;
  color: #231d4f;
  flex: none;
  order: 0;
  flex-grow: 0;
  margin: 0px 15px;
}

.alex-content p {
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  color: #848199;
  flex: none;
  order: 1;
  flex-grow: 0;
  margin: 0px 15px;
}

.tips-heading {
  font-style: normal;
  font-weight: 800;
  font-size: 20px;
  line-height: 27px;
  color: #231d4f;
}

.tips-list li {
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 19px;
  color: #231d4f;
  flex: none;
  order: 1;
  flex-grow: 0;
  margin: 20px 0px;
}

.number-bullet {
  background: #dc0032;
  box-shadow: 0px 4px 12px rgba(220, 0, 50, 0.25);
  border-radius: 50%;
  color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 42px;
  width: 42px;
}

@media (max-width: 1200px) {
  section {
    padding: 10rem 0;
  }
}
</style>
